import { Routes, Route } from 'react-router-dom';
import Callback from './components/Callback';
import OperatorGate from './components/OperatorGate';
import ErrorBoundary from './components/ErrorBoundary';
import OperatorCallback from './components/OperatorCallback';
import OperatorRegistrationGate from './components/OperatorRegistrationGate';

export default function App() {
  return (
    <ErrorBoundary>
      <Routes>
        <Route path="/" element={<OperatorGate />} />
        <Route path="/registration" element={<OperatorRegistrationGate />} />
        <Route path="/callback" element={<Callback />} />
        <Route path="/operatorCallback" element={<OperatorCallback />} />
      </Routes>
    </ErrorBoundary>
  );
}
